import { ButtonProps } from "primereact/button";
import React from "react";
import { useI18n } from "@core/i18n/i18n";
import { useNavigate } from "@core/routing/use-navigate";
import { e2eTestId } from "@e2e/test-ids";
import { Button } from "@ui/components/buttons/button";
import { RoutesPath } from "@ui/navigation/routes";

export const CreateProgramButton: React.FC<Omit<ButtonProps, "children"> & { children?: string }> = props => {
	const { format } = useI18n();
	const navigate = useNavigate();
	return (
		<Button
			{...props}
			data-test={e2eTestId.homePage.createProgramButton}
			label={format("templateListing.createProgramButton")}
			onClick={e => {
				props.onClick?.(e);
				navigate(RoutesPath.TemplateBuilder);
			}}
		/>
	);
};
